<template>
  <div class="block page17 f-r f-c">
    <PageHeader
      :title="moduleData['3_17_1_1']"
      :sub-title="moduleData['3_17_1_1_en']"
      :page-logo="reportCustomization.pageLogo"
    />
    <PageTips :page-num="pageNum"/>
    <div class="page17-body f-r j-b">
      <div class="page17-body-left">
        <div class="page17-body-header f-r j-b a-c">
          <div class="page17-body-header-left">{{ PAGE_TEXT[commonLang].nearbyHotels }} {{ totalSize }} {{ PAGE_TEXT[commonLang].unitStore }}</div>
        </div>
        <TableNav width="900px">
          <template v-slot:title> {{ PAGE_TEXT[commonLang].nearestHotels }} </template>
        </TableNav>
        <PTable :col-data="colData" :row-data="rowData1" style="min-height: 500px">
          <Empty :text="PAGE_TEXT[commonLang].noHotelCoverage" v-if="!rowData1.length"/>
        </PTable>
        <div
          v-if="reportCustomization.showWater"
          class="page-tips2"
        >{{ PAGE_TEXT[commonLang].moreInfo }}</div>

      </div>
      <div class="page17-body-right">
        <div class="page17-body-right f-c">
          <div class="page11-map" id="page11Map">
            <Empty :text="PAGE_TEXT[commonLang].noHotelCoverage" v-if="!rowData1.length"/>
          </div>
          <div class="page11-map-legend f-r a-c f-w">
            <div
              class="page11-map-legend-item f-r a-c"
              v-for="(item, index) in typeList"
              :key="index"
            >
              <div
                class="page11-map-legend-point point1"
                :style="{ background: item.color }"
              ></div>
              {{ item.name }}
            </div>

          </div>
          <div v-if="reportCustomization.showDataSource" class="page11-map-tips">
            {{ PAGE_TEXT[commonLang].dataSource }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import TableNav from "./components/TableNav";
import PTable from "./components/PTable2";
import BarChart from "./components/BarChart2";
import Empty from "./components/Empty";

import AMapLoader from "@amap/amap-jsapi-loader";
import { AMAP_KEY } from "@/constants/common";
import { shallowRef } from "@vue/reactivity";

import { computed, onMounted, ref } from "vue";
import { mapAddCircle, addMapCenter, mapAddPolygonV2 } from "@/utils/pdf";
import { useStore } from "vuex";

import { getMapDelayByMarkerCount } from '@/utils'
import {
  drawMapKeepAlive,
} from '@/api/apiv2'

const props = defineProps({
    pageNum: String,
    cityInfo: {
        type: Object,
        default: () => {
            return {};
        },
    },
    catData: {
        type: Object,
        default: () => {
            return []
        },
    },
    moduleData: {
      type: Object,
      default: () => {
        return {
        };
      },
    },
    // poi改造后数据
    poiData: {
      type: Object,
      default: () => {},
    },
    reportCustomization: {
      type: Object,
      default: () => {},
    },
    commonLang: {
      type: String,
      default: 'zh'
    }
  });

const PAGE_TEXT = {
  'zh': {
    nearbyHotels: '周边酒店 共',
    unitStore: '家',
    nearestHotels: '距离调研地最近的酒店（最多展示各TOP5）',
    noHotelCoverage: '当前区域暂无酒店覆盖',
    moreInfo: '>更多酒店物业评估相关数据，请使用「边界猎手-酒店评估报告」',
    dataSource: '数据来源：旅游平台边界酒旅大数据整合',
    type: '类型',
    nearestHotel: '距离项目最近酒店',
    quantity: '数量',
    noThisType: '该区域暂无此类型'
  },
  'en': {
    nearbyHotels: 'Nearby Hotels Total',
    unitStore: 'stores',
    nearestHotels: 'Hotels Nearest to Research Site (Top 5 Maximum for Each Type)',
    noHotelCoverage: 'No hotel coverage in current area',
    moreInfo: '',
    dataSource: 'Data Source: Tourism platform Boundary hotel & tourism big data integration',
    type: 'Type',
    nearestHotel: 'Nearest Hotel to Project',
    quantity: 'Quantity',
    noThisType: 'No such type in this area'
  }
};

      const color = [
        "#0045FF",
        "#FF7800",
        '#FF0000',
        '#17C49D',
        '#00BEFF',
        '#A933E4',
        '#00FF19',
        '#DACE10',
        '#6694CF',
        '#F53A99',
        '#A1C607',
        '#6005B1',
        '#FF5E87',
      ];
    const store = useStore()
      const colData = computed(() => [
        { prop: "name", width: "147px", label: PAGE_TEXT[props.commonLang].type },
        { prop: "names", width: "497px", label: PAGE_TEXT[props.commonLang].nearestHotel },
        { prop: "count", width: "118px", label: PAGE_TEXT[props.commonLang].quantity },
      ]);

      const rowData1 = computed(() => {
        return props.catData.map((el, index) => {
          return {
            ...el,
            type: el.bhProType,
            name: el.bhProTypeName,
            names: el.poi.slice(0,5).map(el => el.name).join('、') || PAGE_TEXT[props.commonLang].noThisType,
            value: el.poi.length,
            order_price_avg: (el.hotelPriceAvg || '--') + ' 元/晚',
            poi: el.poi || [],
            color: color[index],
          }
        })
      });

      let map = shallowRef(null);
      const addMaker = (amap, map, data, color) => {
        let markerList = [];
        data.forEach((v) => {
          let content = `<div style="width: 12px;height: 12px; border-radius: 50%;background: ${color};"></div>`
          let marker = new amap.Marker({
            position: new amap.LngLat(
              v.location.split(",")[0],
              v.location.split(",")[1]
            ),
            content
          });
          markerList.push(marker);
        });
        map.add(markerList);
      };
      onMounted(() => {
          AMapLoader.load({
              key: AMAP_KEY, // 申请好的Web端开发者Key，首次调用 load 时必填
              version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
              plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
          }).then((AMap) => {
            map = new AMap.Map("page11Map", {
              WebGLParams: {
                  preserveDrawingBuffer:true
              },
              dragEnable: false,
              zoomEnable: false,
              zoom: store.getters.mapZoom, //初始化地图级别
              center: props.cityInfo.location.split(","), //初始化地图中心点位置
            });

            addMaker(AMap, map, rowData1.value.find(el => el.type === 'P030101')?.poi || [], '#0045FF')
            addMaker(AMap, map, rowData1.value.find(el => el.type === 'P030201')?.poi || [], '#FF7800')
            addMaker(AMap, map, rowData1.value.find(el => el.type === 'P030301')?.poi || [], '#FF0000')
            addMaker(AMap, map, rowData1.value.find(el => el.type === 'P030401')?.poi || [], '#17C49D')
            addMaker(AMap, map, rowData1.value.find(el => el.type === 'P030501')?.poi || [], '#00BEFF')
            addMaker(AMap, map, rowData1.value.find(el => el.type === 'P030601')?.poi || [], '#A933E4')
            addMaker(AMap, map, rowData1.value.find(el => el.type === 'P030701')?.poi || [], '#00FF19')

            if (props.cityInfo.is_polygon) {
              mapAddPolygonV2(props.cityInfo?.polygon || '', map)
            } else {
              mapAddCircle(props.cityInfo, map);
            }
            addMapCenter(AMap, map, props.cityInfo.location)

            // 等待地图渲染
            const totalCount = rowData1.value.reduce((a, b) => a + (b?.poi?.length || 0), 0)
            const delay = getMapDelayByMarkerCount(totalCount)
            drawMapKeepAlive(delay).catch((e) => {})

            map.setFitView()
        })
        .catch((e) => {
            console.log(e);
        });
      });

      const typeList = props.catData.map((item, index) => ({
        name: item.bhProTypeName,
        color: color[index],
      }))

      // poi改版
      const totalSize = computed(() => {
        if (!props.poiData || !props.poiData?.nearby?.length) return 0
        const item = props.poiData.nearby.find((n) => n.bhProType === 'P030000')
        return item?.count || 0
      })

      const order_price_avg = computed(() => {
        if (!rowData1.value.length) return '--'
        const length = rowData1.value.filter((item) => !!item.hotelPriceAvg && item.hotelPriceAvg !== '--').length
        if (!length) return '--'
        let value =  rowData1.value.map(el => el?.hotelPriceAvg || 0).reduce((pre,next) => {
          return pre + next
        }, 0) / length
        if (value === 0) return '--'
        return value.toFixed(0) + ' 元/晚'
      })
</script>

<style lang="less">
.page17 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;
  .page17-body {
    flex-grow: 1;
    padding: 67px 20px 0 61px;
    .page17-body-left {
      width: 900px;
      .page17-body-header {
        height: 33px;
        font-size: 24px;

        font-weight: bold;
        color: #333333;
        line-height: 33px;
        margin-bottom: 10px;
      }

      .page-tips2 {
        margin-top: 12px;
      }
    }
    .page17-body-right {
      width: 853px;
      .page11-map {
        position: relative;
        width: 100%;
        height: 760px;
      }
      .page11-map-legend {
        flex-grow: 1;
        padding: 23px 0 23px 46px;
        .page11-map-legend-item {
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
          margin-right: 76px;
        }
        .page11-map-legend-item:last-child {
          margin-right: 0;
        }
        .page11-map-legend-icon {
          width: 22px;
          height: 22px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-right: 12px;
        }
        .icon1 {
          background-image: url("~@/assets/机场.png");
        }
        .icon2 {
          background-image: url("~@/assets/火车站.png");
        }
        .icon3 {
          background-image: url("~@/assets/高铁站.png");
        }
        .page11-map-legend-point {
          width: 22px;
          height: 22px;
          margin-right: 12px;
          border-radius: 50%;
        }

        .point1 {
          background-color: #0045FF;
        }
      }
      .page11-map-tips {
        flex-shrink: 0;
        text-align: right;
        height: 28px;
        font-size: 20px;
        font-weight: 400;
        color: #9a9a9a;
        line-height: 28px;
      }
    }
  }
}
</style>
